import React from 'react';
import styled from 'styled-components';
import Rate from 'rc-rate';
import { StarStyles } from '../../../../styles/theme/default/others';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .star-container {
    text-align: center;
    display: flex;
    align-items: center;
  }
  .total-reviews {
    margin-left: 5px;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;

    color: #6c6c6c;
  }

  @media (max-width: 992px) {
    .total-reviews {
      font-size: 14px;
      line-height: 17px;
    }
  }
`;

function ReviewStars({ averageRating, totalReviews }) {
  return (
    <Wrapper>
      <div
        className="star-container"
        onClick={() => {
          // scrollToReviews();
        }}
      >
        <StarStyles>
          <Rate
            value={parseFloat(averageRating / 2)}
            style={{ fontSize: 16, marginTop: 5 }}
            allowClear={false}
            disabled={true}
            character={<i className="icon-star-rating" />}
            allowHalf
          />
        </StarStyles>
        {/* <div className="total-reviews">{totalReviews} Reviews</div> */}
      </div>
    </Wrapper>
  );
}

export default ReviewStars;
